<template>
  <div>
    <h5 class="mb-3">Datos del usuario</h5>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          :label-cols="2"
          label="Nombre"
          :invalid-feedback="!state.firstName? 'El nombre es invalido': ''"
          :state="state.firstName"
        >
          <b-form-input v-model="user.firstName"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          :label-cols="2"
          label="Apellido"
          :invalid-feedback="!state.lastName? 'El apellido es invalido': ''"
          :state="state.lastName"
        >
          <b-form-input v-model="user.lastName"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          horizontal
          label="Correo"
          :label-cols="2"
          :description="Boolean(verifyInProgress) ? 'Verificando el correo, espere...' : ''"
          :invalid-feedback="emailFeedBack"
          :state="state.email"
        >
          <b-form-input v-model="email"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group 
          v-if="!selectedIsMarketAdmin"
          horizontal
          :label-cols="2"
          label="Sellers"
          :description="selectedIsMarketAdmin ? '' : 'Solo un usuario administrador del Marketplace puede seleccionar más de un Seller'"
          :invalid-feedback="alertInvalidFeedBack()"
          :state="state.sellers && user.id === null">
          <autocomplete
            id="inputSellers"
            class="input_class optional"
            name="inputSellers"
            :maxElements="isAdmin && selectedIsMarketAdmin ? 100 : 1"
            :disabled="!isAdmin"
            placeholder="Ingrese una marca..."
            :provider="getSearchSeller"
            v-model="user.organizations"
            :showSelectAll="selectedIsMarketAdmin"
            :seletecAll="true">
          </autocomplete>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="routeProfile('Usuario')">
      <b-col md="12">
        <hr />
        <h5 class="mb-3">Notificaciones</h5>
        <b-form-group
          horizontal
          :label-cols="3"
          label="Quiero recibir correos electrónicos">
          <c-switch
            inputType="checkbox"
            type="text"
            variant="success"
            on="Si"
            off="No"
            :pill="true"
            v-model="user.sendEmail"
            size="m"
            id="s0">
          </c-switch>
        </b-form-group>
        <hr />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <roles-checkbox :value="user" :options="roleOptions"/>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import {RoleService, AdminServiceMixin, OrganizationService} from '@/mixims/AdminServiceMixin'
import OrganizationsCheckbox from './OrganizationsCheckbox'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
import RolesCheckbox from './RolesCheckbox'
import autocomplete from '@/components/common/vue-autocomplete'
import cSwitch from '@/components/common/Switch'

export default {
  mixins: [RoleService, AdminServiceMixin, OrganizationService, ValidationsMixim],
  components: { OrganizationsCheckbox, RolesCheckbox, autocomplete, cSwitch },
  props: ['user', 'roleOptions', 'allOrganizations'],
  data () {
    return {
      emailValidation: true,
      emailFeedBack: '',
      timeout: null,
      prev: '',
      verifyInProgress: false,
      isAdmin: this.$store.getters.isAdmin
    }
  },
  methods: {
    save (saveAction) {
      this.getRoles().then(res => {
        return res.body
      }).then(r => {
        saveAction(this.user)
      })
    },

    /**
     * establece el mensaje de invalid feedback
     */
    handleInvalidFeedback () {
      if (!this.user.email || this.user.email === '') this.emailFeedBack = 'El email es obligatorio'
      else if (!this.validateEmail(this.user.email, true)) this.emailFeedBack = 'Email inválido'
      else this.emailFeedBack = ''
    },
    alertInvalidFeedBack () {
      const commonAlert = 'Se debe seleccionar'
      return !this.user.organizations.length ? `${commonAlert} al menos un Seller` : !this.selectedIsMarketAdmin && this.user.organizations.length > 1 ? `${commonAlert} solo un Seller` : ''
    },
    routeProfile (nombre) {
      return this.$route.name === nombre
    }
  },
  computed: {
    selectedIsMarketAdmin () {
      return this.user.roles.some(r => r.roleName === 'ADMIN_USER')
    },
    disableSave () {
      return Object.values(this.state).includes(false)
    },
    state () {
      return {
        firstName: this.isValidText(this.user.firstName, true, 20),
        lastName: this.isValidText(this.user.lastName, true, 20),
        email: Boolean(this.user.email) && !this.emailFeedBack,
        roles: Boolean(this.user.roles) && this.user.roles.length > 1,
        sellers: !this.selectedIsMarketAdmin ? (this.alertInvalidFeedBack() === '') : true
      }
    },
    email: {
      set (newVal) {
        this.user.email = newVal
        if (this.user.id && this.prev === newVal) {
          this.emailValidation = true
          clearTimeout(this.timeout)
          return
        }
        this.emailValidation = false
        this.handleInvalidFeedback()
        if (this.validateEmail(newVal, true)) {
          this.verifyInProgress = true
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.existEmail(this.user.email || '').then(res => {
              this.emailValidation = !res.body
              this.verifyInProgress = false
              if (!this.emailValidation) this.emailFeedBack = 'el correo ingresado se encuentra en uso'
            })
          }, 2000)
        }
      },
      get () {
        this.handleInvalidFeedback()
        return this.user.email
      }
    }
  },
  watch: {
    user (newUser, oldUser) {
      if (newUser.id !== oldUser.id) {
        this.prev = newUser.email
      }
    },
    'user.roles' (newVal, oldVal) {
      if (newVal && newVal.some(r => r.roleName === 'ADMIN_USER')) {
        this.user.organizations = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue